import { getRouteParams } from '../../services/angular-bridge';

// Returns the current route's projectId. Centralised so tests can mock a single
// import and so any future route-shape change has one site to touch.
export function useProjectIdFromRoute(): string {
  return getRouteParams().projectId;
}
